import L from "leaflet";
import { LMap, LTileLayer, LPopup } from "vue2-leaflet";
import EoMapIcon from "@/components/MapIcon.vue";
import "./Map.sass";
import "leaflet/dist/leaflet.css";

export default {
  name: "eo-map",
  props: {
    locationsWithCounts: {
      // location list with counts
      type: Array
    },
    settings: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    maxMapHeight: {
      type: Number,
      default: 500
    },
    mapWidth: {
      type: Number
    }
  },
  data() {
    return {
      // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      url: this.settings.tileServer?.url?.length
        ? this.settings.tileServer.url
        : "https://maps.api.eo-heimat.de/tiles/osm-bright/",
      tileParams:
        this.settings.tileServer?.params ||
        `?apiKey=${this.settings.apiKey}`,
      attribution: this.settings?.tileServer?.attribution?.length
        ? this.settings.tileServer.attribution
        : 'Powered by <a href="https://www.geoapify.com/">Geoapify</a>|\n<a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>|\n<a href="http://openmaptiles.org/" target="_blank">© OpenMapTiles</a>',
      positionOnPage: -1,
      isFullHeight: false,
      reduceHeightBy: 0 // calclulated on scroll when map is shown
    };
  },
  components: {
    EoMapIcon,
    LMap,
    LTileLayer,
    LPopup
  },
  mounted() {
    this.positionOnPage =
      this.$refs.mapContainer?.getBoundingClientRect().y + window.pageYOffset;

    // disable zooming
    this.$refs.myMap.mapObject.scrollWheelZoom.disable();
  },
  computed: {
    bounds() {
      const bounds = [];

      if (this.locationsWithCounts) {
        this.locationsWithCounts.forEach(location => {
          // skip events with empty coordinates
          if (
            !location.geo ||
            !location.geo.coordinates ||
            !location.geo.coordinates[0] ||
            !location.geo.coordinates[1]
          )
            return;

          bounds.push(
            L.latLng(location.geo.coordinates[1], location.geo.coordinates[0])
          );
        });
      }

      // set bounds of map to marker bounds
      return L.latLngBounds(bounds);
    },
    rolloverLocationId() {
      return (
        this.$store.state.rolloverMapLocationId ||
        this.$store.state.rolloverCardLocationId
      );
    },
    mapHeight() {
      return this.isFullHeight
        ? window.innerHeight - this.$store.state.mapAbove - this.reduceHeightBy
        : this.maxMapHeight;
    },
    calculatedMapWidth() {
      if (this.mapWidth) {
        return this.mapWidth + "px";
      }
      return "100%";
    },
    locationsForMap() {
      return this.locationsWithCounts?.filter(l => l.geo && l.geo.coordinates) || [];
    }
  },
  methods: {
    // render address once, only on demand...
    formatAddress(location) {
      if (!location.formattedAddress) {
        let address = location.title;

        if (location.address) {
          if (location.address.address)
            address += "<br />" + location.address.address;

          let hasCity = false;
          let locationCity = "";
          if (this.settings.displayLocationCity && location.address.zip) {
            locationCity += location.address.zip.trim();
            hasCity = true;
          }
          if (this.settings.displayLocationCity && location.address.city) {
            if (hasCity) locationCity += " ";
            locationCity += location.address.city.trim();
            hasCity = true;
          }
          if (
            this.settings.displayLocationDistrict &&
            location.address.district
          ) {
            locationCity +=
              (hasCity ? "-" : "") + location.address.district.trim();
          }

          if (locationCity) address += "<br />" + locationCity;

          if (
            this.settings.displayLocationCountry &&
            location.address.country
          ) {
            address += "<br />" + location.address.country.trim();
          }
        }

        // set address
        location.formattedAddress = address;
      }
      return location.formattedAddress;
    },
    searchLocation(location) {
      this.$store.commit("selectLocation", location._id);
    },
    onMouseEnter(location) {
      // set store marker that we have entered location with id
      this.$store.commit("rolloverMapLocationId", location._id);
    },
    onMouseLeave() {
      // clear store marker
      this.$store.commit("rolloverMapLocationId", undefined);
    },
    onScroll() {
      if (!this.isMobile) {
        if (this.positionOnPage >= 0) {
          if (
            window.pageYOffset >=
            this.positionOnPage - this.$store.state.mapAbove
          ) {
            this.$refs.mapContainer.style.position = "fixed";
            this.$refs.mapContainer.style.top =
              this.$store.state.mapAbove + "px";
            this.isFullHeight = true;

            // reduce map height by a certain number if mapBelow is set
            if (this.$store.state.mapBelow > 0) {
              // calculate view port bottom
              const distanceToBottom =
                document.documentElement.scrollHeight -
                window.pageYOffset -
                window.innerHeight;

              // apply modifier
              this.reduceHeightBy =
                distanceToBottom < this.$store.state.mapBelow
                  ? this.$store.state.mapBelow - distanceToBottom
                  : 0;
            }

            this.$refs.myMap.mapObject.invalidateSize();
          } else {
            this.$refs.mapContainer.style.position = "static";
            this.$refs.mapContainer.style.top = "";
            this.$refs.mapContainer.style.bottom = "";
            this.isFullHeight = false;
            this.$refs.myMap.mapObject.invalidateSize();
          }
        }
      }
    }
  }
};
